import { Avatar, Button, CircularProgress, Divider, Fab, Tab, Tabs, Grid, Tooltip, Typography, TextField, Select, MenuItem, InputAdornment, IconButton, Stack, Modal, Table, TableHead, TableRow, TableCell, TableBody, Paper, FormControl, InputLabel, } from "@mui/material";
import searchIcon from "../../icons/searchIcon.svg"
import ThreeSixtyIcon from "@mui/icons-material/ThreeSixty";
import React, { useState, useEffect, useContext } from "react";
import clearFilterImage from "../../../src/icons/clearFilter.svg";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridDensitySelector, getGridStringOperators, } from "@mui/x-data-grid";
import { TABS, ROLES, DATE_FORMATS } from "../../constants";
import { Add, AddAPhoto, AddTask, SaveAlt, SaveAltOutlined, SaveAs, ManageSearch, Send, Search } from "@mui/icons-material";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import "../../App.css";
import { height } from "@mui/system";
import { set } from "date-fns";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile &&
    `
      position: relative;
      `}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
`;
const TableContainer = styled.div`
  //   height: calc(
  //     100vh - ${isMobile
        ? "56px - 20px - 82.23px"
        : "128px - 29px - 50.77px"}
  //   );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;
const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  //   border: solid 1px lightGrey;
  display: ${isMobile ? "flex" : "grid"};
  border-radius: 4px;
  ${isMobile &&
    `
    flex-direction: column;
  `}
`;
const TabsContainer = styled.div`
  ${isMobile &&
    `
    height: calc(100vh - 56px - 20px - 43.77px);
  `}
`;
const AllotedSpecimen = () => {
    // Modal state for verify dialog
    const [verifyModalOpen, setVerifyModalOpen] = useState(false);
    const [verifyModalData, setVerifyModalData] = useState(null);
    const [approveModalOpen, setApprovedModalOpen] = useState(false);
    const [approvedModalData, setApprovedModalData] = useState(null);
    const [selectedDistanceType, setSelectedDistanceType] = useState("");
    // const [verifyRemark, setVerifyRemark] = useState("");
    const [approvedRemark, setApprovedRemark] = useState("");

    // Only allow input with at least one alphanumeric character
    const handleApprovedRemarkChange = (e) => {
        const value = e.target.value;
        if (/.*[a-zA-Z0-9].*/.test(value) || value === "") {
            setApprovedRemark(value);
        }
    };
    const location = useLocation();
    const selectedTabProp1 = location.state?.selectedTabProp;
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
    const [rowCount, setRowCount] = useState();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [rsms, setRsms] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [asms, setAsms] = useState([]);
    const [rms, setRms] = useState([]);
    const [rm, setRm] = useState("")
    const [rsm, setRsm] = useState("")
    const [asm, setAsm] = useState("")
    const [userModal, setUserModal] = useState(null);
    const [visibleEmployees, setVisibleEmployees] = useState([]);
    const [selectedMember, setSelectedMember] = useState(null);
    const [selectedTab, setSelectedTab] = useState(selectedTabProp1 || TABS.REGISTERED);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(20)
    const [accessModulesData, setAccessModulesData] = useState([]);
    const [filter, setFilter] = useState(false);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
    const [search, setSearch] = useState()
    const [newRows, setNewRows] = useState([])
    const [modalData, setModalData] = useState([])
    const [newOrderStatus, setNewOrderStatus] = useState("");
    const [openViewModal, setOpenViewModal] = useState(false)
    const [allowanceStatus, setAllowanceStatus] = useState("")
    const [sessions, setSessions] = useState([]); // from API
    const [selectedSession, setSelectedSession] = useState("");
    const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
    const [isSessionDisabled, setIsSessionDisabled] = useState(false);
    const [filteredDate, setFilteredData] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        fetchSessions();
    }, []);

    const fetchSessions = async () => {
        try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            // if (response?.data) {
            //   setSessions(response.data);
            // }
            if (response?.status) {
                const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
                setFilteredData(filterdData1[0])
            }
            else {
                window.NotificationUtils.showError("Something Went Wrong in session")
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!startDate && !endDate) {
            setIsSessionDisabled(false);
        }
    }, [startDate, endDate]);

    // const getStartAndEndDates = () => {
    //   const now = new Date();
    //   const start = new Date(now.getFullYear(), now.getMonth(), 15);
    //   const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    //   return { start, end };
    // };

    // const getStartAndEndDates = () => {
    //   const now = new Date();
    //   const year = now.getFullYear();
    //   const month = now.getMonth(); // 0-indexed
    //   const date = now.getDate();

    //   let start, end;

    //   if (date <= 15) {
    //     start = new Date(year, month, 1);
    //     end = new Date(year, month, 15);
    //   } else {
    //     start = new Date(year, month, 16);
    //     end = new Date(year, month + 1, 0); // last day of the current month
    //   }

    //   return {
    //     start: start.toISOString().split("T")[0],
    //     end: end.toISOString().split("T")[0],
    //   };
    // };
    const getStartAndEndDates = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth(); // 0-based
        const day = now.getDate();

        let start, end;

        if (day <= 15) {
            start = new Date(year, month, 1);
            end = new Date(year, month, 15);
        } else {
            start = new Date(year, month, 16);
            end = new Date(year, month + 1, 0); // last day of the month
        }

        // format as YYYY-MM-DD in local timezone
        return {
            start: start.toLocaleDateString('en-CA'),
            end: end.toLocaleDateString('en-CA'),
        };
    };

    useEffect(() => {
        const { start, end } = getStartAndEndDates();

        if (!filter) {
            setStartDate(start);
            setEndDate(end);
        }
    }, []);

    useEffect(() => {
        // Only call fetch when dates are set
        // getUpdatedAllowances()
        if (startDate && endDate) {
            fetchEmployees();
        }
    }, [paginationModel.page, paginationModel.pageSize, filter, newOrderStatus]);


    useEffect(() => {
        fetchAccessModules();
        if (userData?.role.toLowerCase().includes('admin')) {
            getAllUsers()
        }
        if (userData?.role == 'rsm') {
            getUsers('rsm', userData?.id)
        }
        if (userData?.role == 'asm') {
            getUsers('asm', userData?.id)
        }
    }, [])

    async function getAllUsers() {
        let results = await window.Platform.database.fetchEmployees()
        if (results?.status) {
            window.NotificationUtils.showError(results.message);
            setLoading(false);
            return;
        }
        else {
            setAllUsers(results?.data)
            setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
            setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
            setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
            setLoading(false);
        }
    }

    async function getUsers(role, id) {
        if (id != "") {
            let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
            if (role == 'rsm') {
                setAsms(results?.data)
                setRms(results?.data1)
            }
            if (role == 'asm') {
                setRms(results?.data)
            }
        } else {
            if (role == 'rsm') {
                setRm("")
                setAsm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
                setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
            }
            if (role == 'asm') {
                setRm("")
                setRms(allUsers?.filter((ele) => ele.role == 'se'))
            }
        }

    }


    const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId: userData?.id,
                moduleId: "2mcEyrlAXR"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }


    const verifyAllowance = async (data1, selectedDistance, remark) => {
        setLoading(true);
        try {
            const payload1 = {
                status: data1.status,
                amount: selectedDistance,
                ownerId: data1.data1.userId,
                date: data1.data1.visitDate,
                // verifyRemark: remark,
            };
            // console.log(payload1, "11111111111111122222233333333");
            // return;

            let results = await window.Platform.database.verifyAllowance(payload1);
            if (results?.status === false) {
                setLoading(false);
                setVerifyModalOpen(false);
                setSelectedDistanceType("");
                fetchEmployees();
                // setVerifyRemark("");
            } else {
                window.NotificationUtils.showError("Error Fetching Data");
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Something Went Wrong");
        } finally {
            setLoading(false);
        }
    }

    const approveAllowance = async (approvedModalData1) => {
        // console.log(approvedModalData1, "sdsdddd");
        setLoading(true);
        try {
            const payload1 = {
                status: approvedModalData1.status,
                ownerId: approvedModalData1.data1.userId,
                approvedRemark: approvedRemark,
                id: approvedModalData1.data1.updateAllowanceId,
                date: approvedModalData?.data1?.visitDate
            };
            // console.log(payload1, "payload");
            // return;
            let results = await window.Platform.database.approveAllowance(payload1);
            if (results?.status === false) {
                setLoading(false);
                setApprovedModalOpen(false);
                fetchEmployees();
                setApprovedRemark("");
            } else {
                window.NotificationUtils.showError("Error Fetching Data");
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            window.NotificationUtils.showError("Something Went Wrong");
        } finally {
            setLoading(false);
        }
    }

    const handleOpenViewModal = (id) => {
        console.log(id, "isdsdsdsd")
        setModalData(id)
        setOpenViewModal(true);
    }

    const handleCloseViewModal = () => {
        setOpenViewModal(false);
        setModalData([]);
    }

    const formatDate1 = (dateStr) => {
        if (!dateStr) return "N/A";
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
    };

    const schoolColumns = () => {
        const stringOperators = getGridStringOperators().filter((op) =>
            ["contains"].includes(op.value)
        );

        let result = [
            {
                field: "name11",
                headerName: "Name",
                width: 200,
                filterable: false,
                sortable: false,
                valueGetter: (params) => {
                    let name = params.row.name || "N/A"
                    return name;
                },
                renderCell: (params) => {
                    let name = params.row.name || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
                        </Tooltip>
                    );
                },
            },
            // {
            //     field: "empId1",
            //     headerName: "User Name",
            //     width: 150,
            //     filterable: false,
            //     sortable: false,
            //     valueGetter: (params) => {
            //         let name = params.row.username || "N/A"
            //         return name;
            //     },
            //     renderCell: (params) => {
            //         let name = params.row.username || "N/A";
            //         return (
            //             <Tooltip title={name || "N/A"}>
            //                 <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            //             </Tooltip>
            //         );
            //     },
            // },
            {
                field: "role1",
                headerName: "Role",
                minWidth: 200,
                valueGetter: (params) => {
                    let name = params.row?.roleName || "N/A";
                    return name || "N/A"
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row?.roleName || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "reportingManagerName",
                headerName: "Reporting Manager",
                minWidth: 210,
                valueGetter: (params) => {
                    let name = params.row.reportingManagerName;
                    return name;
                },
                sortable: false,
                filterOperators: stringOperators,
                renderCell: (params) => {
                    let name = params.row.reportingManagerName || "N/A";
                    return (
                        <Tooltip title={name || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "seriesName",
                headerName: "Series Name",
                minWidth: 150,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={(params.row.seriesName)?.toUpperCase() || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}> {(params.row.seriesName)?.toUpperCase() || "N/A"} </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "12SkuName",
                headerName: "SKU Name",
                minWidth: 210,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.nameSku || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}> {params.row.nameSku || "N/A"} </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "quantity1",
                headerName: "Quantity",
                minWidth: 90,
                sortable: false,
                filterable: false,
                renderCell: (params) => {
                    return (
                        <Tooltip title={params.row.quantity || "N/A"}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}> {params.row.quantity || "N/A"} </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "createdAt",
                headerName: "Uploaded Date",
                sortable: false,
                width: 180,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let dateStr = params.row.specimenCreatedAt;
                    let name = "N/A";
                    if (dateStr) {
                        const dateObj = new Date(dateStr);
                        name = dateObj.toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                        });
                    }
                    return (
                        <Tooltip title={name}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {name}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
            {
                field: "updatedAt",
                headerName: "Updated Date",
                sortable: false,
                width: 180,
                filterOperators: stringOperators,
                editable: false,
                renderCell: (params) => {
                    let dateStr = params.row.specimenUpdatedAt;
                    let name = "N/A";
                    if (dateStr) {
                        const dateObj = new Date(dateStr);
                        name = dateObj.toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                        });
                    }
                    return (
                        <Tooltip title={name}>
                            <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>
                                {name}
                            </Typography>
                        </Tooltip>
                    );
                },
            },
        ].filter(Boolean);
        return result;
    };

    const exportTADAExcel = async () => {
        // if (!rm && !asm) {
        //   window.NotificationUtils.showWarning("Please Select RM or ASM");
        //   return;
        // }
        setLoading(true);
        try {
            let data = {
                // fromDate: startDate,
                // toDate: endDate,
                // fromDate: startDate != '' ? startDate : filteredDate?.startDate,
                // toDate: endDate != '' ? endDate : filteredDate?.endDate,
                ownerName: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                fromDate: startDate !== '' ? startDate : filteredDate?.startDate,
                toDate: endDate !== '' ? endDate : filteredDate?.endDate,
            }
            let result = await window.Platform.database.exportData("specimen/downloadUploadedSpecimens",
                data
            )
            const blob = new Blob([result.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const now = new Date();
            const formattedDate = `${now.getDate().toString().padStart(2, '0')}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getFullYear()}`;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `uploaded_specimens_${formattedDate}.xlsx`);
            // link.setAttribute("download", "attendance.xlsx");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Export error:", error);
            window.NotificationUtils.showError("Failed to export data. Please Select Correct user.");
        }
    }

    const handleTabChange = async (value, keepSelected = false) => {
        setVisibleEmployees([]);
        if (!keepSelected) {
            setSelectedMember(null);
        }
        setFilter(false);
        setSelectedTab(value);
    };

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            setVisibleEmployees([]);

            let results = await window.Platform.database.getAllottedSpecimen({
                // rsm, asm, ownerId, startDate, endDate 
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                ownerId: rm,
                rsm: userData?.role == 'rsm' ? userData?.id : rsm,
                asm: userData?.role == 'asm' ? userData?.id : asm,
                startDate: startDate != '' ? startDate : filteredDate?.startDate,
                endDate: endDate != '' ? endDate : filteredDate?.endDate,
            });
            setNewRows(results?.data)
            setRowCount(results?.data1)

            const jsonArrayWithId = results?.data?.map((obj, index) => ({
                ...obj,
                id: index + 1,
            }));
            setVisibleEmployees(jsonArrayWithId);
            // setLoading(false);
            if (results.success) {
                setLoading(false);
            } else {
                setLoading(false);
                window.NotificationUtils.showError(results.message);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const getUpdatedAllowances = async () => {
        setLoading(true);
        try {
            setVisibleEmployees([]);

            let results = await window.Platform.database.getUpdatedAllowances({});
            // setNewRows(results?.data)
            // setRowCount(results?.data1)

            // const jsonArrayWithId = results?.data?.map((obj, index) => ({
            //   ...obj,
            //   id: index + 1,
            // }));
            // setVisibleEmployees(jsonArrayWithId);
            // setLoading(false);
            // if (results.status) {
            //   setLoading(false);
            // } else {
            //   setLoading(false);
            //   window.NotificationUtils.showError(results.message);
            // }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const clearFilter = async () => {
        setLoading(true);
        setRsm("");
        setAsm("");
        setRm("");
        setStartDate("")
        setEndDate("")
        setAllowanceStatus("")
        setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
        setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
        setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
        setSelectedSession("");
        setVisibleEmployees([]);
        setRowCount(0);
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth(); // 0-based
        const day = now.getDate();

        let start, end;

        if (day <= 15) {
            start = new Date(year, month, 1);
            end = new Date(year, month, 15);
        } else {
            start = new Date(year, month, 16);
            end = new Date(year, month + 1, 0); // last day of the month
        }
        setStartDate(start.toLocaleDateString('en-CA'))
        setEndDate(end.toLocaleDateString('en-CA'))
        setLoading(false);
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />

                <GridToolbarFilterButton />

                {/* <GridToolbarDensitySelector /> */}

                <GridToolbarExport
                    csvOptions={{
                        fileName: "users-report",
                    }}
                />
            </GridToolbarContainer>
        );
    }
    const renderTabContent = () => {
        return (<>
            <div className="d-flex  align-items-center  py-2">
                {/* <Button
          onClick={() => setNewOrderStatus("")}
          style={{ backgroundColor: newOrderStatus === "" ? "#8787f470" : "white", color: newOrderStatus === "" ? "#000000" : "black", fontWeight: "500", }}>
          All
        </Button>
        <Button
          onClick={() => setNewOrderStatus(0)}
          style={{ backgroundColor: newOrderStatus === 0 ? "blue" : "white", color: newOrderStatus === 0 ? "white" : "black", fontWeight: "500", }}>
          Verified
        </Button>
        {userData?.role != "asm" && <> <Button
          onClick={() => setNewOrderStatus(1)}
          style={{ backgroundColor: newOrderStatus === 1 ? "green" : "white", color: newOrderStatus === 1 ? "white" : "black", fontWeight: "500", }}>
          Approved
        </Button>
        </> } */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          px: 2,
                          py: 1,
                          background: "#e8f5e9",
                          border: "1px solid #a5d6a7",
                          borderLeft: "4px solid #2e7d32",
                          borderRadius: "8px",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                          width: "fit-content",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            fontWeight: 600,
                            color: "#1b5e20",
                            letterSpacing: "0.3px",
                          }}
                        >
                          Total Entries:
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "15px",
                            fontWeight: 700,
                            color: "#2e7d32",
                            background: "#fff",
                            px: 1.2,
                            // py: 0.2,
                            borderRadius: "6px",
                            border: "1px solid #a5d6a7",
                            minWidth: "28px",
                            textAlign: "center",
                          }}
                        >
                          {rowCount || 0}
                        </Typography>
                      </Box>
        
                <Typography variant="body1" ml={3} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
                <Select
                    value={paginationModel.pageSize}
                    variant="outlined"
                    size="small"
                    onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
                    sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
                >
                    {[10, 20, 30, 50, 100].map((role) => (
                        <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
                    ))}
                </Select>
            </div>
            <DataGridContainer
                style={{ height: !visibleEmployees.length ? "200px" : "auto" }}
            >
                <DataGrid
                    className="payrollGrid"
                    density="compact"
                    rows={visibleEmployees || []}
                    columns={schoolColumns()}
                    sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}

                    disableSelectionOnClick
                    disableRowSelectionOnClick

                    onRowClick={(rowParams, event) => {
                        setUserModal(rowParams.row);
                    }}
                    rowHeight={60}
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                />
            </DataGridContainer>
        </>
        );
    };

    return (
        <>
            <StaffEditorPageContainer>
                <Button variant="text" startIcon={<ArrowBackIos />} sx={{ display: "flex" }} onClick={() => navigate(-1)}> Back </Button>

                <HeaderContainer>
                    <Box sx={{ mt: 1, width: "100%" }}>
                        <Paper elevation={3}
                            sx={{
                                p: 2,
                                mb: 2,
                                width: '100%',        // takes full width of parent
                                // maxWidth: '1000px',   // optional: control max width
                                mx: 'auto',
                                backgroundColor: "#ebf0fa"          // center it horizontally
                            }}>
                            <div className="container-fluid" style={{ width: "100%" }}>
                                <div className="row">
                                    {userData?.role.includes('admin') && <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                                            <Select
                                                value={rsm}
                                                label="Select HO"
                                                size="small"
                                                onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm("") }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {rsms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    {userData?.role != 'asm' && <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                                            <Select
                                                value={asm}
                                                label="Select ARM"
                                                size="small"
                                                onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm(""); }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {asms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>}
                                    <div className="col-md-3">
                                        <FormControl size="small" fullWidth>
                                            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                                            <Select
                                                value={rm}
                                                label="Select RM"
                                                size="small"
                                                onChange={(e) => { setRm(e.target.value) }}
                                            >
                                                <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                                                {rms.map((role) => (
                                                    <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                         <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="success" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => exportTADAExcel()}>
                                            Download
                                        </Button>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <TextField label="From Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <FormControl fullWidth size="small">
                                            <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }}
                                                inputProps={{
                                                    style: { color: "black", fontSize: "13px", fontWeight: 500 }
                                                }} />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3">
                                        <Button variant="contained" size="small" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => fetchEmployees()}>
                                            Find
                                        </Button>
                                    </div>
                                      <div className="col-md-3">
                                        <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" size="small" fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => clearFilter()}>
                                            Clear Filters
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Paper>
                    </Box>
                </HeaderContainer>
                <TableContainer>
                    <TabsContainer>
                        {/* <StyledTabs
              variant="fullWidth"
              value={selectedTab}
              onChange={(event, value) => handleTabChange(value)}
              indicatorColor="primary"
              textColor="primary"
            > */}
                        {/* <Tab label="Travel Allowance" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} /> */}
                        {/* {<Tab label="Daily Allowance" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }} />} */}
                        {/* </StyledTabs> */}
                        {loading && <OpaqueLoading />}

                        {renderTabContent()}
                    </TabsContainer>
                </TableContainer>
            </StaffEditorPageContainer>

            <Modal open={verifyModalOpen} onClose={() => setVerifyModalOpen(false)}>
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 800,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}>
                    <Typography variant="h6" mb={2} sx={{ fontWeight: "800", color: "black" }} textAlign="center">Verify Allowance</Typography>
                    {/* <Typography variant="h6" mb={2} sx={{ fontWeight: "800", color: "black" }} textAlign="center">Verify Allowance  ({verifyModalData?.data1?.name} - {new Date(verifyModalData?.data1?.visitDate).toLocaleDateString('en-GB')})</Typography> */}
                    <Stack direction="row" spacing={2} mb={2}>
                        <Typography sx={{ fontWeight: "700", color: "black", display: "flex", alignItems: "center" }}>Select Distance Type: </Typography>
                        <Button
                            variant={selectedDistanceType === "user" ? "contained" : "outlined"}
                            color="primary"
                            onClick={() => setSelectedDistanceType("user")}
                        >
                            User Reported Distance <br /> ({verifyModalData?.data1?.userGeneratedDistance || "N/A"})
                        </Button>
                        <Button
                            variant={selectedDistanceType === "system" ? "contained" : "outlined"}
                            color="secondary"
                            onClick={() => setSelectedDistanceType("system")}
                        >
                            System Generated Distance <br /> ({verifyModalData?.data1?.systemGenerated_distance || "N/A"})
                        </Button>
                    </Stack>
                    {/* <TextField
            label="Verify Remark"
            fullWidth
            multiline
            minRows={2}
            value={verifyRemark}
            onChange={e => setVerifyRemark(e.target.value)}
            sx={{ mb: 2 }}
          /> */}
                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                        <Button variant="outlined" onClick={() => {
                            setVerifyModalOpen(false);
                            setSelectedDistanceType("");
                            // setVerifyRemark("");
                        }}>Cancel</Button>
                        <Button
                            variant="contained"
                            color="success"
                            disabled={!selectedDistanceType}
                            onClick={() => {
                                const selectedDistance = selectedDistanceType === "user"
                                    ? verifyModalData?.data1?.userGeneratedDistance == "Auto Out" ? null : verifyModalData?.data1?.userGeneratedDistance
                                    : verifyModalData?.data1?.systemGenerated_distance;
                                verifyAllowance(verifyModalData, selectedDistance);
                            }}
                        >
                            Submit
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={approveModalOpen} onClose={() => setApprovedModalOpen(false)}>
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 800,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}>
                    <Typography variant="h6" mb={2} sx={{ fontWeight: "800", color: "black" }} textAlign="center"> {approvedModalData?.status == 1 ? "Approve Allowance" : "Reject Allowance"} </Typography>
                    <h4 style={{ color: "black", fontWeight: "500" }}>
                        Name :- {approvedModalData?.data1?.name}
                    </h4>
                    <h4 style={{ color: "black", fontWeight: "500" }}>
                        Verified Amount :- {approvedModalData?.data1.verifiedAmount || 0}
                    </h4>
                    <h4 style={{ color: "black", fontWeight: "500" }}>
                        Verified By :- {approvedModalData?.data1?.verifyByName}
                    </h4>
                    <h3 style={{ color: "black", fontWeight: "500" }} >
                        You Are About to Approve KM Travelled by User and Verified by Manager. Are you sure to Proceed?
                    </h3>
                    <TextField
                        label="Remark"
                        fullWidth
                        multiline
                        value={approvedRemark}
                        onChange={handleApprovedRemarkChange}
                        sx={{ mb: 2 }}
                    />

                    <Stack direction="row" spacing={2} justifyContent="flex-end">

                        <Button variant="outlined" onClick={() => {
                            setApprovedModalOpen(false);
                            setApprovedRemark("");
                        }}>Cancel</Button>
                        <Button
                            variant="contained"
                            color="success"
                            disabled={approvedModalData?.status == 2 && !approvedRemark}
                            onClick={() => {
                                approveAllowance(approvedModalData);
                            }}
                        >
                            Submit
                        </Button>

                    </Stack>
                </Box>
            </Modal>
        </>
    );
};

export default AllotedSpecimen;